import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
    Html: {
        videoTpl: `
            <video muted loop>
                <source src="{{src}}" />
                Sorry, your browser doesn't support embedded videos.
            </video>
            `,
    },
    Carousel: {
        Navigation: false,
        transition: 'slide'
    },
    compact: false,
    contentClick: 'close',
    Thumbs: false,
    Toolbar: {
        enabled: true,
        display: {
            left: [],
            middle: ["prev", "infobar", "next"],
            right: ["close"],
        },
        parentEl: () => {
            return document.querySelector(".fancybox__footer") || null;
        }
    },
});
